import { JsonObject, JsonProperty, AbstractModel } from 'projects/core/src/public-api';
import { UserRole } from 'projects/core/src/lib/login/data/user-role';

@JsonObject('model.CheckItemTag')
export class CheckItemTag extends AbstractModel {
    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(Number, 'pos')
    pos: number;

    @JsonProperty(String, 'color')
    color?: string;

    @JsonProperty(String, 'group')
    group?: string;

    @JsonProperty(String, 'name')
    name?: string;

    @JsonProperty(String, 'title')
    title?: string;

    @JsonProperty(UserRole, 'role')
    role?: UserRole;
}